import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AutoInfracao } from "@/models/auto_infracao";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

import { VUE_APP_SIT_WS_API_URL, VUE_APP_SIT_API_URL } from "@/commons/config";
import { map } from "rxjs/operators";

const autoInfracaoNotificar = require("@/query/autos-infracao/AutoInfracaoNotificar.graphql");
const autoInfracaoNotificarAtualizar = require("@/query/autos-infracao/AutoInfracaoNotificarAtualizar.graphql");
const autoInfracaoDividaAtiva = require("@/query/autos-infracao/AutoInfracaoDividaAtiva.graphql");
const autoInfracaoDividaAtivaPorPlaca = require("@/query/autos-infracao/AutoInfracaoDividaAtivaPorPlaca.graphql");
const autoInfracaoGerarDae = require("@/query/autos-infracao/AutoInfracaoGerarDae.graphql");

export class AutoInfracaoAPI extends BaseAPI<AutoInfracao> {
  constructor() {
    super();
    this.graphqlUrl;
    this.apiUrl = VUE_APP_SIT_WS_API_URL;
  }

  public loadAutosInfracaoNotificar(
    cnpj: string,
    token: string,
    numOrdem: number
  ): AxiosObservable<AutoInfracao[]> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(autoInfracaoNotificar),
        variables: {
          inputAutoInfracao: {
            cnpj,
            token,
            numOrdem
          }
        }
      })
      .pipe(
        map((data: any) => {
          const { autoInfracaoANotificar } = data;

          if (!autoInfracaoANotificar) return null;

          return autoInfracaoANotificar;
        })
      );
  }

  public loadAutosInfracaoNotificarAtualizar(
    cnpj: string,
    token: string,
    numOrdem: number
  ): AxiosObservable<AutoInfracao[]> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(autoInfracaoNotificarAtualizar),
        variables: {
          inputAutoInfracao: {
            cnpj,
            token,
            numOrdem
          }
        }
      })
      .pipe(
        map((data: any) => {
          const { autoInfracaoANotificarAtualizar } = data;

          if (!autoInfracaoANotificarAtualizar) return null;

          return autoInfracaoANotificarAtualizar;
        })
      );
  }

  public autoInfracaoAptosDividaAtiva(
    cnpj: string,
    token: string,
    numOrdem: number
  ): AxiosObservable<AutoInfracao[]> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(autoInfracaoDividaAtiva),
        variables: {
          inputAutoInfracao: {
            cnpj,
            token,
            numOrdem
          }
        }
      })
      .pipe(
        map((data: any) => {
          const { autoInfracaoAptosDividaAtiva } = data;

          if (!autoInfracaoAptosDividaAtiva) return null;

          return autoInfracaoAptosDividaAtiva.map((auto: any) => {
            return new AutoInfracao(
              auto.numeroAitp,
              auto.numeroAitp,
              auto.placa,
              auto.dataLavratura,
              auto.descricaoInfracao,
              auto.valor,
              `R$ ${parseFloat(Number(auto.valor).toFixed(2))}`
            );
          });
        })
      );
  }

  public imprimirAutosInfracao(autos: Array<string>): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/public/autos-infrigements/generateAutosPdf/`,
      autos,
      { responseType: "blob" }
    );
  }

  public findBy(
    cnpj: string,
    placa: string,
    renavam: string
  ): AxiosObservable<AutoInfracao[]> {
    return this.axios.post(`${VUE_APP_SIT_API_URL}/boletos/consultaAutos`, {
      cnpj,
      placa,
      renavam
    });
  }

  public gerarAutoInfracaoDae(
    cnpj: string,
    taxasAutos: Array<string>,
    transportadoraId: number,
    placa: string,
    recaptcha: string,
    numOrdem: string,
  ): AxiosObservable<any> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(autoInfracaoGerarDae),
        variables: {
          inputBoletoMulta: {
            taxasAutos: taxasAutos,
            transportadoraId: transportadoraId,
            placa: placa,
            cnpjTransportadora: cnpj,
            recaptcha: recaptcha,
            numOrdem
          }
        }
      })
      .pipe(
        map((data: any) => {
          const { geraBoletoMulta } = data;

          if (!geraBoletoMulta) return null;

          return geraBoletoMulta.extrato;
        })
      );
  }

  public autoInfracaoAptosDividaAtivaPorPlaca(
    cnpj: string,
    token: string,
    numOrdem: number,
    placa: string
  ): AxiosObservable<AutoInfracao[]> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(autoInfracaoDividaAtivaPorPlaca),
        variables: {
          inputAutoInfracaoPorPlaca: {
            cnpj,
            token,
            numOrdem,
            placa
          }
        }
      })
      .pipe(
        map((data: any) => {
          const { autoInfracaoAptosDividaAtivaPorPlaca } = data;

          if (!autoInfracaoAptosDividaAtivaPorPlaca) return null;

          return autoInfracaoAptosDividaAtivaPorPlaca.map((auto: any) => {
            return new AutoInfracao(
              auto.numeroAitp,
              auto.numeroAitp,
              auto.placa,
              auto.dataLavratura,
              auto.descricaoInfracao,
              auto.valor,
              `R$ ${parseFloat(Number(auto.valor).toFixed(2))}`
            );
          });
        })
      );
  }
}
